module.exports = __webpack_public_path__ + "static/fonts/ProximaNova-Black.f401366.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/ProximaNova-Black.otf
// module id = EEoV
// module chunks = 1